import * as React from 'react';
import Options from '../../../../../common/components/Options';
import LoaderIcon from '../../../../../common/components/loader/LoaderIcon';
import {MarketingStepProps} from '../../../../types/mx/farrera/components';

class MarketingStepView extends React.Component<MarketingStepProps, {}> {

    render() {
        return (
            <div className="container px-0">
                <div className="row">
                    <div className="col py-3">
                        <h3 className="text-poppins text-secondary-lighten-1">¿Cómo nos conoció?</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col pb-2">
                        <label className="text-poppins">
                            Cuéntanos cómo te enteraste del servicio de financiamiento de Motorfy
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        {this.props.channelReferents.length > 0 ?
                            <Options id={'mkt'} name={'mkt'}
                                     options={this.props.channelReferents}
                                     listGroupClass="list-group-flush"
                                     customClassLabel="marketing"
                                     onChange={this.props.onSelectMarketingChannel}/>
                            : <LoaderIcon/>}
                    </div>
                </div>
            </div>
        );
    }
}

export default MarketingStepView;
